exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vdp-datepicker .form-control[readonly] {\n    background-color: #ffffff !important;\n}\n.vdp-datepicker__calendar{\n    width: 100% !important;\n}\n", ""]);

// exports
